<!-- Loading -->
<div *ngIf="!venue" class="venue-loading">
    <ng-lottie [options]="{path: 'assets/lotties/loading.json'}" containerClass="loading-box"></ng-lottie>
</div>

<div class="venue-page" *ngIf="venue">

    <div class="venue-layout">

        <!-- Col 1 fila 1: Card info principal -->
        <div class="venue-card info-card">
            <div class="venue-card-header">
                <i class="fa-light fa-building card-icon"></i>
                <h3 class="card-title">Datos del espacio</h3>
            </div>
            <div class="venue-card-body">
                <div class="info-fields">

                    <!-- Nombre -->
                    <div class="field-group">
                        <label class="field-label">NOMBRE DEL ESPACIO</label>
                        <div class="field-input clickable" (click)="openUpdateVenue('name', 'Nombre')">
                            <span>{{venue?.name || '—'}}</span>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>

                    <!-- Localización -->
                    <div class="field-group">
                        <label class="field-label">LOCALIZACIÓN</label>
                        <div class="field-input clickable" (click)="openUpdateVenue('address', 'Localización')">
                            <span>{{venue?.address || '—'}}</span>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>

                    <!-- Descripción -->
                    <div class="field-group">
                        <label class="field-label">DESCRIPCIÓN</label>
                        <div class="field-input field-input-multiline clickable" (click)="openUpdateVenue('description', 'Descripción')">
                            <span>{{venue?.description || 'Sin descripción. Haz clic para añadir.'}}</span>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>

                    <!-- URL -->
                    <div class="field-group">
                        <label class="field-label">
                            URL PERSONALIZADA
                            <i class="fas fa-info-circle icon-info-label" matTooltip="Identificador único que forma parte del enlace público de este espacio en Citylok."></i>
                        </label>
                        <p class="field-helper">Crea un enlace personalizado de tu espacio para compartirlo y promocionar tus eventos fácilmente.</p>
                        <div class="field-input clickable" (click)="openUpdateVenue('slug', 'URL personalizada')">
                            <div class="d-flex align-items-center gap-2">
                                <i class="fal fa-link" style="color: var(--color-primary); font-size: 0.85rem;"></i>
                                <a class="link-value" [href]="getVenuePublicUrl()" target="_blank" (click)="$event.stopPropagation()">{{getVenuePublicUrl()}}</a>
                                <i class="fal fa-copy pointer-in" matTooltip="Copiar enlace" [matTooltipShowDelay]="0" style="color: var(--color-primary); font-size: 0.85rem;" (click)="$event.stopPropagation(); copyVenueUrl()"></i>
                            </div>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Col 2 fila 1: Foto de portada -->
        <div class="venue-card cover-card">
            <div class="venue-card-header">
                <i class="fa-light fa-image card-icon"></i>
                <h3 class="card-title">Foto de portada</h3>
            </div>
            <div class="cover-card-body">
                <div class="cover-image-wrapper" (click)="file.click()">
                    <div class="cover-img-box">
                        <i class="fa-thin fa-image" *ngIf="!imgControl.value"></i>
                        <img *ngIf="imgControl.value" [src]="imgControl.value" alt="Portada espacio" />
                    </div>
                    <div class="cover-camera-btn">
                        <i class="fa-light fa-camera"></i>
                    </div>
                    <input id="file" #file hidden type="file" accept="image/*" (change)="onFileChange($event)">
                </div>
                <p class="cover-hint">Haz clic en la imagen para cambiarla</p>
            </div>
        </div>

        <!-- Fila 2: Aforo + Condiciones generales (misma anchura que info-card) -->
        <div class="venue-row-cards" *ngIf="!(venue.map || venue.map_version)">

            <!-- Card aforo -->
            <div class="venue-card capacity-card">
                <div class="venue-card-header">
                    <i class="fa-light fa-users card-icon"></i>
                    <h3 class="card-title">Aforo</h3>
                </div>
                <div class="venue-card-body">
                    <div class="info-fields">
                        <div class="field-group">
                            <label class="field-label">AFORO MÁXIMO</label>
                            <div class="field-input clickable" (click)="openUpdateVenue('capacity', 'Aforo')">
                                <span>{{venue?.capacity ? (venue.capacity + ' personas') : 'Sin límite. Haz clic para añadir.'}}</span>
                                <i class="fa-light fa-pen field-icon"></i>
                            </div>
                        </div>

                        <p class="capacity-map-notice" *ngIf="!isSuperAdmin">
                            <i class="fa-light fa-circle-info capacity-map-notice-icon"></i>
                            Para crear un mapa de butacas, por favor, ponte en contacto con los administradores de Citylok.
                        </p>
                        <div class="d-flex justify-content-center">
                            <button *ngIf="isSuperAdmin" class="btn-create-map" (click)="goToMap()">
                                <i class="fa-light fa-map"></i>Crear mapa de butacas
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Card suscriptores (desactivada temporalmente) -->
            <!-- <div class="venue-card subs-card">
                <div class="venue-card-header">
                    <i class="fa-light fa-user-plus card-icon"></i>
                    <h3 class="card-title">Suscriptores</h3>
                </div>
                <div class="subs-toggle-row">
                    <div class="subs-toggle-info">
                        <span class="subs-toggle-label">Permitir suscriptores</span>
                        <span class="subs-toggle-helper">Activa esta opción para que los usuarios puedan suscribirse a este espacio.</span>
                    </div>
                    <mat-checkbox color="primary" [(ngModel)]="venue.allow_subscription" (change)="updateAllowSubscribers()"></mat-checkbox>
                </div>
                <div *ngIf="venue.allow_subscription" class="subs-fields">
                    <div class="field-group">
                        <label class="field-label">NOMBRE DE SUSCRIPTORES</label>
                        <div class="field-input clickable" (click)="openUpdateVenue('membership_title', 'Nombre de suscriptores')">
                            <span>{{venue?.membership_title || membershipTitle}}</span>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>
                    <div class="field-group">
                        <label class="field-label">TEXTO DE SUSCRIPCIÓN</label>
                        <div class="field-input field-input-multiline clickable" (click)="openUpdateVenue('subscription_text', 'Texto de suscripción')">
                            <span>{{venue?.subscription_text || subscriptionText}}</span>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Condiciones generales -->
            <div class="venue-card conds-card">
                <div class="venue-card-header">
                    <i class="fa-light fa-file-contract card-icon"></i>
                    <h3 class="card-title">Condiciones generales</h3>
                </div>
                <div class="venue-card-body">
                    <div class="conds-text clickable" (click)="openUpdateVenue('general_conditions', 'Condiciones generales')">
                        <span *ngIf="venue?.general_conditions" [innerHTML]="venue.general_conditions"></span>
                        <span *ngIf="!venue?.general_conditions" class="conds-empty">Sin condiciones generales definidas. Haz clic para añadir.</span>
                        <i class="fa-light fa-pen field-icon"></i>
                    </div>
                </div>
            </div>

        </div>

        <!-- Fila 2 (con mapa): solo condiciones generales -->
        <div class="venue-row-cards" *ngIf="venue.map || venue.map_version">

            <!-- Card suscriptores (desactivada temporalmente) -->
            <!-- <div class="venue-card subs-card">
                <div class="venue-card-header">
                    <i class="fa-light fa-user-plus card-icon"></i>
                    <h3 class="card-title">Suscriptores</h3>
                </div>
                <div class="subs-toggle-row">
                    <div class="subs-toggle-info">
                        <span class="subs-toggle-label">Permitir suscriptores</span>
                        <span class="subs-toggle-helper">Activa esta opción para que los usuarios puedan suscribirse a este espacio.</span>
                    </div>
                    <mat-checkbox color="primary" [(ngModel)]="venue.allow_subscription" (change)="updateAllowSubscribers()"></mat-checkbox>
                </div>
                <div *ngIf="venue.allow_subscription" class="subs-fields">
                    <div class="field-group">
                        <label class="field-label">NOMBRE DE SUSCRIPTORES</label>
                        <div class="field-input clickable" (click)="openUpdateVenue('membership_title', 'Nombre de suscriptores')">
                            <span>{{venue?.membership_title || membershipTitle}}</span>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>
                    <div class="field-group">
                        <label class="field-label">TEXTO DE SUSCRIPCIÓN</label>
                        <div class="field-input field-input-multiline clickable" (click)="openUpdateVenue('subscription_text', 'Texto de suscripción')">
                            <span>{{venue?.subscription_text || subscriptionText}}</span>
                            <i class="fa-light fa-pen field-icon"></i>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Condiciones generales -->
            <div class="venue-card conds-card">
                <div class="venue-card-header">
                    <i class="fa-light fa-file-contract card-icon"></i>
                    <h3 class="card-title">Condiciones generales</h3>
                </div>
                <div class="venue-card-body">
                    <div class="conds-text clickable" (click)="openUpdateVenue('general_conditions', 'Condiciones generales')">
                        <span *ngIf="venue?.general_conditions" [innerHTML]="venue.general_conditions"></span>
                        <span *ngIf="!venue?.general_conditions" class="conds-empty">Sin condiciones generales definidas. Haz clic para añadir.</span>
                        <i class="fa-light fa-pen field-icon"></i>
                    </div>
                </div>
            </div>

        </div>

    </div>

</div>

